import React, { useEffect, useState } from 'react';
import LcLoading from '../../../../components/Generic/LcLoading';
import ReactECharts from 'echarts-for-react';
import { useSelector } from 'react-redux';
import { PatchManagerService } from '../../../../services/patchmanager/patchManagerService';
import { RootState } from '../../../../store';
import { UserState } from '../../../../store/reducers/userReducer';
import LcNoData from '../../../../components/Generic/LcNoData';
import { GraphModel } from '../../../../services/patchmanager/patchManagerModel';

interface graphData {
    labels: Array<string>
    data: Array<number>
    colors: Array<string>
}

const MissingPatchesGraph: React.FC = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const patchManagerService = new PatchManagerService(props);
    const [loading, setLoading] = useState<boolean>(false);
    const [graphData, setGraphData] = useState<graphData>({
        labels: [],
        data: [],
        colors: []
    })

    const getColorsGraph = (SOName: string): string => {
        const color = {
            'Crítico': '#dc291e',
            'Importante': "#ffa400",
            'Moderado': "#f6de00",
            'Baixo': "#3ebb3f",
            'Não classificado': "#cccccf",
        };
        return color[SOName];
    }

    const GetPatchSummariesMissingSeverity = async () => {
        try {
            const missingResponse = await patchManagerService.GetPatchSummariesMissingSeverity();
            setGraphData(buildGraphData(missingResponse))

        } catch (error) {
            console.error('Error:', error);
        }
    }

    const buildGraphData = (data: GraphModel[]) => {
        return {
            labels: data.map(label => label.name),
            data: data.map(dados => dados.value),
            colors: data.map(cor => getColorsGraph(cor.name))
        }
    }

    useEffect(() => {
        setLoading(true);
        GetPatchSummariesMissingSeverity()
            .finally(() => setLoading(false))
    }, [user.ClientGroupSelected, user.refreshFlag]);

    function GetOptions(graphDataLocal) {
        const option = {
            tooltip: {
                backgroundColor: '#f1f5fb',
                borderWidth: 0,
                textStyle: {
                    fontSize: 11,
                    fontFamily: 'Inter',
                    color: '#2B304F',
                },
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            grid: {
                top: '5%',
                bottom: '0%',
                left: '0%',
                width: '100%',
                containLabel: true,

            },
            xAxis: {
                type: 'category',
                data: graphDataLocal.labels,
                show: true,
                axisLabel: {
                    interval: 0,
                    fontSize: 9
                }
            },
            yAxis: {
                type: 'value',
                show: true,
            },
            series: [
                {
                    data: graphDataLocal.data,
                    itemStyle: {
                        color: (params) => graphDataLocal.colors[params.dataIndex],
                        borderRadius: [4, 4, 0, 0],
                        borderColor: '#fff',
                        borderWidth: 0,

                    },
                    type: 'bar',
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(58, 79, 135, 0.4)',
                        }
                    }

                }
            ]
        }

        return option;
    }

    return (
        <LcLoading loading={loading} label="Carregando gráfico...">
            {
                graphData && graphData.data && graphData.data.length > 0 && graphData.colors.length > 0 && graphData.labels.length > 0 ?
                    <ReactECharts
                        opts={{ renderer: 'svg', locale: 'PT-br' }}
                        className='MissingPatchesGraph'
                        option={GetOptions(graphData)}
                        style={{ width: '100%' }}
                    />
                    :
                    <LcNoData size="default" />
            }
        </LcLoading>
    );
}

export default MissingPatchesGraph;